import React from 'react';

import { CategoryItem } from 'ggApp/types/api/CategoryItem';
import { getCategoryFilterSuffix } from 'ggApp/utils/urlBuilder/getCategoryFilterSuffix';

import { Background, Icon, Name, SubcategoryLink, Wrap } from './styled';

type ItemProps = {
    name?: string;
    iconPath?: string;
    isActiveCategory?: boolean;
    onClick?: () => void;
    permalink?: string;
    subcategories?: CategoryItem[];
    isEUNonBusinessStore: boolean;
};

// react-aim needs a class component to work
export class Item extends React.PureComponent<ItemProps> {
    render() {
        const {
            name,
            iconPath,
            isActiveCategory = false,
            permalink,
            onClick = () => undefined,
            subcategories = [],
            isEUNonBusinessStore,
        } = this.props;

        return (
            <>
                <Wrap
                    isActiveCategory={isActiveCategory}
                    to={permalink}
                    onClick={onClick}
                    type="catalog-link"
                >
                    <Background isActiveCategory={isActiveCategory} />
                    {iconPath !== undefined && (
                        <Icon iconPath={iconPath} isActiveCategory={isActiveCategory} />
                    )}
                    <Name isActiveCategory={isActiveCategory}>{name}</Name>
                </Wrap>
                {/* These sub categories are only for crawlers and not visible in UI */}
                {subcategories.map((subcategory) => (
                    <SubcategoryLink
                        key={subcategory.id}
                        to={`${subcategory.permalink}${getCategoryFilterSuffix(
                            subcategory,
                            isEUNonBusinessStore,
                        )}`}
                    >
                        {subcategory.name}
                    </SubcategoryLink>
                ))}
            </>
        );
    }
}
